export default __webpack_public_path__ + "static/background-76763a96ebd5f8e68a8b4896291b2d33.jpg";